import React from "react";
import nutrimeasure from "../../img/portfolio/nutrimeasure_722x450.jpg";

const RightPaneCK = () => {
  return (
    <div className="rightPane">
      <h4>Nutrimeasure</h4>
      <img src={nutrimeasure} alt="Nutrimeasure app home page" />
    </div>
  );
};

export default RightPaneCK;
